/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Response from single notification send
 * @export
 * @interface SingleNotificationResponse
 */
export interface SingleNotificationResponse {
    /**
     * Temporal workflow ID for tracking
     * @type {string}
     * @memberof SingleNotificationResponse
     */
    workflowId?: string;
    /**
     * ACS message ID (populated when workflow completes; null if async)
     * @type {string}
     * @memberof SingleNotificationResponse
     */
    messageId?: string;
    /**
     * Whether the workflow was started successfully
     * @type {boolean}
     * @memberof SingleNotificationResponse
     */
    success?: boolean;
    /**
     * Error message if success is false
     * @type {string}
     * @memberof SingleNotificationResponse
     */
    error?: string;
    /**
     * When send was blocked by outbound policy (governance), actionable reason for UI
     * @type {string}
     * @memberof SingleNotificationResponse
     */
    blockReason?: string;
}

/**
 * Check if a given object implements the SingleNotificationResponse interface.
 */
export function instanceOfSingleNotificationResponse(value: object): value is SingleNotificationResponse {
    return true;
}

export function SingleNotificationResponseFromJSON(json: any): SingleNotificationResponse {
    return SingleNotificationResponseFromJSONTyped(json, false);
}

export function SingleNotificationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SingleNotificationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'workflowId': json['workflowId'] == null ? undefined : json['workflowId'],
        'messageId': json['messageId'] == null ? undefined : json['messageId'],
        'success': json['success'] == null ? undefined : json['success'],
        'error': json['error'] == null ? undefined : json['error'],
        'blockReason': json['blockReason'] == null ? undefined : json['blockReason'],
    };
}

export function SingleNotificationResponseToJSON(json: any): SingleNotificationResponse {
    return SingleNotificationResponseToJSONTyped(json, false);
}

export function SingleNotificationResponseToJSONTyped(value?: SingleNotificationResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'workflowId': value['workflowId'],
        'messageId': value['messageId'],
        'success': value['success'],
        'error': value['error'],
        'blockReason': value['blockReason'],
    };
}

